import React from "react";
import { CardElement } from "@stripe/react-stripe-js";
import { getString } from "../../utilities";
import { getLangCode, language } from "../../config";

export default function PaymentFields({ setCreditComplete, submitErrors, setSubmitErrors }) {
  const elementOptions = {
    ...(getLangCode() === language.default && { style: { base: { textTransform: "capitalize" } } }),
  };

  return (
    <>
      <div className="cta">{getString("manage.payment.credit")}</div>

      <CardElement
        onChange={(data) => {
          setCreditComplete(data.complete);

          if (submitErrors) {
            setSubmitErrors(null);
          }
        }}
        options={elementOptions}
      />
    </>
  );
}
